import {ApiResponse} from "../interfaces";

class ActionRefreshAndScrollStrategy {
    private readonly actionFunction: (controlId: string, needRefresh: boolean) => void;
    private object: ApiResponse;
    constructor(func: () => void) {
        this.actionFunction = func;
    }

    /**
     * Определяет по объекту случай когда выполнится execute (Если условие проходит, то выполняется)
     * @param object
     */
    public shouldExecute(object: ApiResponse) {
        this.object = object;

        //Условие выполнится только если надо поставить фокус, и обновить форму
        return object.refresh_form && object.focus_control;
    }

    /**
     * Выполняет действие. Внутри вызывает функцию которая выполняет нужное действие
     */
    public execute() {
        const { focus_control, refresh_form } = this.object;
        this.actionFunction(focus_control, refresh_form);
    }
}
export default ActionRefreshAndScrollStrategy;